@if (showRelatedFleetSwapLoading()) {
  <app-modal-loading-section [loading]="true"></app-modal-loading-section>
} @else {
  <onyx-information-heading>
    {{ heading() | translate }}

    @if (isInProgress()) {
      <onyx-dot titleIcon [color]="color()" [pulse]="true"></onyx-dot>
    }
  </onyx-information-heading>

  <div class="container">
    <app-order-modal-realization-status
      [order]="order()"
      [currentOrderPoint]="currentPoint()"
      [currentSwapPoint]="currentSwapPoint()"
      [pointData]="pointData()"
      [color]="color()"
    ></app-order-modal-realization-status>

    <app-order-modal-realization-point
      [order]="order()"
      [currentPoint]="currentPoint()"
      [currentSwapPoint]="currentSwapPoint()"
      [color]="color()"
    ></app-order-modal-realization-point>
  </div>
}
